import '@babel/polyfill';
jQuery(function ($) {
    $('body').addClass('jquery-add-class');
});
const wrapCharSpan = function (str) {
    return [...str].map((char) => `<span>${char}</span>`).join('');
};
const target = document.querySelectorAll('#js-span');
target.forEach(function (target) {
    target.innerHTML = wrapCharSpan(target.textContent);
    target.classList.add('c-animation-txt');
    target.classList.add('js-scroll');
});
const fax = document.querySelectorAll('#js-fax');
const faxIcon = document.querySelectorAll('.js-fax-box');
const tel = document.querySelectorAll('#js-tel');
const telIcon = document.querySelectorAll('.js-tel-box');
if (fax) {
    fax[1].addEventListener('mouseover', function () {
        console.log('Im Fax!');
        faxIcon[1].classList.add('fax-active');
    });
    fax[1].addEventListener('mouseleave', function () {
        faxIcon[1].classList.remove('fax-active');
    });
}
if (tel) {
    tel[1].addEventListener('mouseover', function () {
        console.log('Im Tel!');
        telIcon[1].classList.add('tel-active');
    });
    tel[1].addEventListener('mouseleave', function () {
        telIcon[1].classList.remove('tel-active');
    });
}
let windowWidth = window.innerWidth;
let windowSm = 769;
window.addEventListener('load', () => {
    const kvSwiper = document.querySelector('#kv-swiper');
    if (kvSwiper) {
        var swiper = new Swiper('.kvSwiper', {
            loop: true,
            effect: "fade",
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            speed: 2000,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }
    var mySwipers = [];
    for (var i = 1; i <= 11; i++) {
        mySwipers[i - 1] = new Swiper('.mySwiper' + i, {
            loop: true,
            effect: "fade",
            autoplay: {
                delay: 3000,
                disableOnInteraction: true,
            },
            speed: 1500,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
        mySwipers[i - 1].autoplay.stop();
        (function (index) {
            window.addEventListener('scroll', function () {
                var position = document.querySelector('.mySwiper' + index).getBoundingClientRect().top + window.pageYOffset - window.innerHeight + 100, scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                if (scrollTop > position) {
                    mySwipers[index - 1].autoplay.start();
                }
                else {
                }
            });
        })(i);
    }
});
